export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productores"])},
          "total_number_crop_fields": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campos"])},
          "total_hectares": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hectáreas"])},
          "total_square_meters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["m²"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestionar"])},
          "download_crop_fields_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar campos"])}
        }
      },
      "en": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producers"])},
          "total_number_producers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producers"])},
          "download_crop_fields_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar campos"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manage"])}
        }
      }
    }
  })
}